import React from "react";
import { connect } from "react-redux";
import withStyles from "@material-ui/core/styles/withStyles";
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import extendedTablesStyle from "../../assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.jsx";
import ReactTable from "react-table";

// Icons
//core components
import TextField from "@material-ui/core/TextField";
// import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "../../components/Grid/GridItem.jsx";
import Card from "../../components/Card/Card.jsx";
// import CardBody from "components/Card/CardBody.jsx";
// import CardIcon from "components/Card/CardIcon.jsx";
// import CardHeader from "components/Card/CardHeader.jsx";
// import Avatar from "@material-ui/core/Avatar";
// import IconButton from "@material-ui/core/IconButton";
// import Icon from "@material-ui/core/Icon";
// import Tooltip from "@material-ui/core/Tooltip";
// import Switch from "@material-ui/core/Switch";
// import green from "@material-ui/core/colors/green";
// import DeleteModel from "../../components/Common/FevoModels/DeleteModel";
import { getCustomerData } from "../../actions/customerActions";
import toastr from "toastr";
import axios from "axios";
import { domain } from "../../utils/util";
import { Button, CardContent } from "@material-ui/core";
import { Form } from "react-bootstrap";

class ManageCustomers extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      category: "",
      isEdit: false,
      addCategory: false,
      catData: null,
    };
  }

  componentDidMount = () => {
    let categoryId = this.props.match.params.id;
    // let categoryId = window.location.pathname.split("/")[3];
    // debugger;
    let isEdit = window.location.pathname.split("/")[2] === "editCategory";

    let addCategory = window.location.pathname.split("/")[2] === "addCategory";
    // console.log(isEdit, window.location.pathname.split("/")[2], addCategory);
    this.setState({ isEdit, addCategory });
    // this.props.fetchUsers()
    // this.props.getCustomerData();
    let data = JSON.parse(localStorage.getItem("BerPay_Admin"));
    let config = {};
    if (data) {
      config = {
        headers: { Authorization: `Bearer ${data.token}` },
      };
    }
    axios
      .get(`${domain}/setting/category/${categoryId}`, config)
      .then((res) => {
        if (res.data.statusCode === 200 || res.data.statusCode === 201) {
          this.setState({
            catData: res.data.data,
            category: res.data.data.name,
          });
        }
      })
      .catch((error) => {});
  };

  submitForm = (e) => {
    e.preventDefault();
    let body = {
      name: this.state.category,
    };
    let data = JSON.parse(localStorage.getItem("BerPay_Admin"));
    let config = {};
    if (data) {
      config = {
        headers: { Authorization: `Bearer ${data.token}` },
      };
    }
    if (this.state.isEdit) {
      let catData = this.state.catData;
      console.log(e);
      axios
        .put(`${domain}/setting/category/${catData._id}`, body, config)
        .then((res) => {
          if (res.data.statusCode === 200 || res.data.statusCode === 201) {
            toastr.success("Category Updated Successfully!");
            this.props.history.goBack();
          } else {
            toastr.error(res.data.message);
          }
        })
        .catch((error) => {});
    } else {
      console.log(e);

      axios
        .post(`${domain}/setting/category`, body, config)
        .then((res) => {
          if (res.data.statusCode === 200 || res.data.statusCode === 201) {
            toastr.success("Category Added Successfully!");
            this.props.history.goBack();
          } else {
            toastr.error(res.data.message);
          }
        })
        .catch((error) => {});
    }
  };

  handleChange = (event) => {
    this.setState({ ...this.state, [event.target.name]: event.target.value });
  };

  render() {
    const { classes } = this.props;
    const { category, type, isEdit, addCategory, catData } = this.state;
    return (
      <div>
        <Card>
          <CardContent>
            <Form onSubmit={this.submitForm}>
              <GridItem xs={12}>
                <TextField
                  autoFocus
                  margin="dense"
                  name="category"
                  id="name"
                  label="Category Name"
                  type="name"
                  disabled={!isEdit && !addCategory}
                  onChange={this.handleChange}
                  fullWidth
                  value={category}
                  style={{ marginBottom: "20px" }}
                  required
                />
              </GridItem>
              <GridItem xs={12}>
                <TextField
                  autoFocus
                  margin="dense"
                  name="category-type"
                  label="Category Type"
                  type="name"
                  disabled={true}
                  onChange={this.handleChange}
                  fullWidth
                  value={"goods"}
                  style={{ marginBottom: "20px" }}
                  required
                />
              </GridItem>
              <GridItem xs={12} className="new_Card">
                {(addCategory || isEdit) && (
                  <Button variant="contained" color="primary" type="submit">
                    Submit
                  </Button>
                )}
              </GridItem>
            </Form>
          </CardContent>
        </Card>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    // users: state.products.categories
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getCustomerData: () => dispatch(getCustomerData()),
    // fetchCategories: ()=> dispatch(fetchCategories()),
    // categoryFormContent: (obj) => {dispatch({ type: PRODUCT_CATEGORY_ACTION.OPEN_CATEGORY_FORM, payload: obj })},
    // editCategory: (obj) => dispatch(editCategory(obj)),
    // deleteCategory: (obj,callback) => dispatch(deleteCategory(obj,callback)),
  };
};

const ManageCustumersComponent = withStyles(extendedTablesStyle)(
  ManageCustomers
);
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ManageCustumersComponent);
